/* @flow */

import React, {Component} from 'react';
import {error} from '../../../../../components/ErrorToast/ErrorToast';
import OpenFileViewScss from './OpenFileView.scss';
import DownloadUtil from '../../../../../utils/DownloadUtil';
import AppsUtil from '../../../../../utils/AppsUtil';
import Url from '../../../../../utils/Url';
import {getHeadingTextId, getBodyTextId, WORKFLOWS} from '../stringUtil';

type Props = {
	className: ?string,
	source: string,
	isFileDownloadSuccess: boolean,
	displayCoachMark: Function,
	handleAnalyticsEvent: Function,
	onGetHelp: Function,
	product: Object,
	intl: Object
};

export default class OpenFileView extends Component<Props, State> {
	productDetails: Object;

	constructor(props: Props) {
		super(props);
		this.productDetails = this.props.product;
	}

	componentDidMount() {
		this.props.isFileDownloadSuccess ? this.props.displayCoachMark(false, () => {}, true) : error(this.props.intl.formatMessage({id: 'apps.loggedOutCampaign.openFile.error'}), {timeout: 0, msgId: 'download-file-error'});
	}

	onRestartDownload = (e: Object) => {
		e.preventDefault();
		const isSuccess = DownloadUtil.downloadFile(Url.getParam('file'));
		if (!isSuccess) {
			error(this.props.intl.formatMessage({id: 'apps.loggedOutCampaign.openFile.error'}), {timeout: 0, msgId: 'download-file-error'});
		}
		else {
			this.props.displayCoachMark(true, () => {}, true);
		}
		this.props.handleAnalyticsEvent({
			eventObj: {
				type: 'click',
				subtype: isSuccess ? 'restart-file-download' : 'restart-file-download-fail',
				value: isSuccess ? undefined : 'invalid-path'
			}
		});
	};

	renderHeaderText = () => (
		<div data-cs-mask='' className={OpenFileViewScss.title}>
			{this.props.intl.formatMessage(
				{id: getHeadingTextId(WORKFLOWS.KAIZEN, this.props.source, this.productDetails.sapCode)},
				{
					appName: this.productDetails.name,
					userName : AppsUtil.getImsData().name
				}
			)}
		</div>
	);

	renderBodyText = () => {
		let appname = this.productDetails.name;
		// Remove this in future if requirements do not change.
		if (appname === null) {
			appname = '{firstapp}';
		}
		return (
			<div className={`${OpenFileViewScss.body} ${OpenFileViewScss.loggedOutCampaign}`}>
				<div className={OpenFileViewScss.productBody}>
					<div className={OpenFileViewScss.shallowInstructions}>
						{this.props.intl.formatMessage(
							{
								id: getBodyTextId(WORKFLOWS.KAIZEN, this.props.source, this.productDetails.sapCode, false)
							},
							{
								appname
							}
						)}
					</div>
				</div>
			</div>
		);
	};

	renderHeaderIcon = () => {
		const productData = AppsUtil.getFFCProductConfigBySapCode(this.productDetails.sapCode);
		const icon = AppsUtil.getProductIcon(productData);
		return icon ? (<img alt={this.productDetails.name} src={icon} />) : [];
	}

	render() {
		return (
			<div className={`${OpenFileViewScss.openFileView} ${this.props.className || ''}`}>
				{this.renderHeaderIcon()}
				{this.renderHeaderText()}
				{this.renderBodyText()}
			</div>
		);
	}
}
